/**
 * Построение текста ошибки исчерпания квоты с учётом типа пользователя.
 * При статусе 429 спрашиваем квоту, чтобы отличить PAYG-клиента (есть balance_rub)
 * от сотрудника (нет balance_rub). На других ошибках квоту не запрашиваем.
 */

import { authService } from '../services/authService';
import { metricsService } from '../services/metricsService';
import { quotaBlockedMessage } from './quota';

/** При ошибке загрузки возвращает текст блокировки или null. Квоту спрашивает только при 429. */
export async function resolveQuotaBlockedError(err) {
  // Спрашиваем квоту только при 429 — это единственный случай, когда она влияет на текст
  if (err?.response?.status !== 429) {
    return quotaBlockedMessage(err, null);
  }

  // При 429: получаем квоту, чтобы понять, есть ли у человека баланс
  let quota = null;
  const tokenData = authService.getTokenData();
  if (tokenData?.email) {
    try {
      quota = await metricsService.getQuota(tokenData.email);
    } catch {
      // Не достучались — покажем общий текст, это лучше пустого экрана
    }
  }
  return quotaBlockedMessage(err, quota);
}
